/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Checking_EmailInputs */

const en_admin_create_checking_email = /** @type {(inputs: Admin_Create_Checking_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checking email...`)
};

const de_admin_create_checking_email = /** @type {(inputs: Admin_Create_Checking_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prüfe E-Mail...`)
};

/**
* | output |
* | --- |
* | "Checking email..." |
*
* @param {Admin_Create_Checking_EmailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_checking_email = /** @type {((inputs?: Admin_Create_Checking_EmailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Checking_EmailInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_checking_email(inputs)
	return en_admin_create_checking_email(inputs)
});